// extracted by mini-css-extract-plugin
export default {"title":"orderArticles_title__0qIwc","container":"orderArticles_container__B5CK6","table":"orderArticles_table__6vALA","root":"orderArticles_root__uWtL+"};